import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ChapterTag, Marquee } from "./shared";

export default function Chapter1Timeline({ config }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end end"] });
  const items = config.timeline;
  const x = useTransform(scrollYProgress, [0.05, 0.95], ["2%", `-${(items.length - 1) * 60}%`]);

  return (
    <section ref={ref} className="relative h-[380vh] bg-warm-white" data-testid="chapter-1">
      <div className="sticky top-0 flex h-screen flex-col justify-center overflow-hidden">
        <div className="px-6 md:px-16">
          <ChapterTag n={1} title="Cómo nos conocimos" />
          <h2 className="mb-16 max-w-2xl font-serif text-4xl font-light leading-tight tracking-tight text-deep-black md:text-6xl">
            Una historia contada en <span className="italic text-gold-soft">instantes</span>.
          </h2>
        </div>

        <motion.div style={{ x }} className="flex gap-8 px-6 md:gap-16 md:px-16">
          {items.map((m, i) => (
            <div
              key={i}
              data-testid={`timeline-item-${i}`}
              data-cursor="hover"
              className="group relative w-[78vw] shrink-0 border-t border-deep-black/15 pt-8 md:w-[38vw]"
            >
              <span className="font-serif text-7xl font-light text-champagne transition-colors duration-500 group-hover:text-gold md:text-8xl">
                {m.year}
              </span>
              <div className="mt-4 flex items-center gap-3">
                <span className="h-2 w-2 rounded-full bg-gold" />
                <h3 className="font-serif text-2xl text-deep-black md:text-3xl">{m.title}</h3>
              </div>
              <p className="mt-4 max-w-sm text-sm font-light leading-relaxed text-deep-black/60 md:text-base">
                {m.text}
              </p>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export function StoryMarquee() {
  return (
    <div className="bg-warm-white py-2">
      <Marquee items={["Un encuentro", "Una historia", "Un para siempre"]} />
    </div>
  );
}
